<template>
    <div class="body">
        <p  class="font1" style="padding-top: 13vh;">追逐荣耀，踏实前行，</p>
        <p  class="font1" style="padding-top: 1vh;">勤劳不懈，辉煌绽放。</p>
        <div style="width: 80%;margin: 0 auto;margin-top: 3vh;">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">2024年第一季度你参加的活动有：</p>
            <ul v-for="(item,index) in activityName" :key="index">
                <li>{{ item }}</li>
            </ul>
        </div>
        <div style="width: 80%;margin: 0 auto;margin-top: 3vh;" v-if="certificate[0]!==null">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">2024年第一季度你获得的证书有：</p>
            <ul v-for="(item,index) in certificate" :key="index">
                <li>{{ item}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ["ReportData"],
    data(){
        return{
           activityName:[],
           certificate:[]
        }
    },
    created(){
        const activity=JSON.parse(this.ReportData.activity)
        activity.forEach(obj => {
            // 将每个对象中的"name"和"certificate"的值分别存储到对应的数组中
            this.activityName.push(obj.name);
            this.certificate.push(obj.certificate);
            console.log(this.certificate,'证书');
        });
    }}
</script>

<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/logo1.png") right  top  no-repeat,
                url("../../assets/24March/bg.jpg")  no-repeat;
    background-size: 17% 8%,117px 50px,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    /* text-align: center; */
}
li {
    align-items: center;
    margin-bottom: -13px; /* 可调整列表项之间的间距 */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 80%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 30px;
    font-weight: bold;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

</style>